import React from 'react';
import PropTypes from 'prop-types';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import moment from 'moment';

class FailedTaskItem extends React.Component {
  _renderFailedTaskInfo() {
    const { data, strings } = this.props;
    const replaceMap = {
      count: data.count,
      failed: <b>{strings.failed}</b>,
      task: data.count > 1 ? strings.taskPlural : strings.task,
    };

    return (
      <div className="vf-header-notification__item__content">
        <Components.CircleIcon
          className="vf-header-notification__item__content__icon"
          iconClassName="versa-close"
          innerIconColor={Theme.Color.$bluelighter1}
          outerIconColor={Theme.Color.$red}
        />
        <div className="vf-header-notification__item__content__description">
          {Utils.TranslationHelper.replaceTag(strings.itemDescription, replaceMap)}
        </div>
      </div>
    );
  }

  render() {
    const { data, strings } = this.props;
    const today = moment();
    const todayDate = [today.get('year'), today.get('month'), today.get('date')];
    const diff = today.diff(moment(data.date), 'days', false);
    let date;
    if (diff >= 4) {
      date = moment(data.date).format('DD/MM/YYYY');
    } else {
      switch (diff) {
        case 0:
          date = strings.today;
          break;
        case 1:
          date = strings.yesterday;
          break;
        default:
          date = moment(data.date).from(todayDate, false);
          break;
      }
    }

    return (
      <div
        className="vf-header-notification__item"
        id="vf-header-notification__failed-item"
        onClick={() => this.props.onClick(this.props.data)}
      >
        {this._renderFailedTaskInfo()}
        <div className="vf-header-notification__item__created-time">
          {date}
        </div>
      </div>
    );
  }
}

FailedTaskItem.displayName = 'Failed Task Item';

FailedTaskItem.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string,
    count: PropTypes.number,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  strings: PropTypes.shape().isRequired,
};

export default translate('Notification.FailedTask')(FailedTaskItem);
